import { useTranslation } from 'react-i18next';
import { Button } from '@treezor/design-system';

import { STEPS, useAuth2FaContext } from '@/features/2fa/context/Auth2FaContext';

export function Auth2FaRegistrationSuccess() {
  const { t } = useTranslation();

  const { setCurrentStep } = useAuth2FaContext();

  return (
    <div className="flex flex-col gap-6">
      <span className="typo-body-regular-paragraphLarge text-primary">
        {t('pages.auth.2fa.changePasswordInvitation')}
      </span>
      <Button onClick={() => setCurrentStep(STEPS.CHANGE_PASSWORD)} className="w-fit">
        {t('pages.auth.2fa.completeSecuritySetup')}
      </Button>
    </div>
  );
}
